import classNames from 'classnames';
import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslate } from '../../../mixins/translate/translate';

export function EditPanelFilterAsyncSelect(props: {
    name?: string;
    placeholder?: string;
    notSelectedText?: string;
    value: { label: string };
    disabled?: boolean;
    topLabel?: string;
    notValid?: boolean;
    onChange: (value: string | undefined) => void;
    loadOptions: (inputValue: string) => Promise<{ value: string; label: string }[]>;
}) {
    const translate = useTranslate();
    const classValue = classNames({
        field: true,
        select: true,
        mt5: props.topLabel,
        'state-error': props.notValid,
    });

    const placeholder = props.placeholder ?? `${translate('common.select')}...`;

    return (
        <>
            {props.topLabel && <span className="ml5">{props.topLabel}</span>}
            <label className={classValue} style={{ height: '30px' }}>
                <AsyncSelect
                    styles={{
                        menu: (s: any) => ({ ...s, zIndex: 999, marginTop: '5px' }),
                        menuPortal: (s: any) => ({ ...s, zIndex: 9999 }),
                        control: (s: any) => ({ ...s, borderRadius: '2px', height: '3em', borderColor: '#ddd' }),
                    }}
                    key={props.value}
                    isClearable={true}
                    loadOptions={props.loadOptions}
                    menuPortalTarget={document.body}
                    placeholder={placeholder}
                    name={props.name}
                    isDisabled={props.disabled}
                    onChange={(option: { value: string } | null) => props.onChange(option?.value ?? undefined)}
                    backspaceRemoves={true}
                    isMulti={false}
                    inputProps={{ autoComplete: 'off', autoCorrect: 'off', spellCheck: 'off' }}
                    valueKey="value"
                    labelKey="label"
                    value={props.value}
                />
            </label>
        </>
    );
}
